import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { systemUsersRoute, usersRoute } from 'src/app/app-routing.module';
import { Register } from 'src/app/common-components/register/models/register';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { GetRoleDetail_role_userRolesConnection_items } from 'src/app/pages/role-details/queries/generated/GetRoleDetail';
import { UserRegisterOptions } from '../../models/user-register-options';
import { UserRegisterListItem } from '../../models/user-register-results.model';
import { UsersFilterOption } from '../../models/users-filter-option';
import {
   roleUsersInitialQuickFilter,
   userRegisterAdapterActions,
   userRegisterInitialFilter,
} from '../../state/user-register.actions';
import * as userRegisterReducer from '../../state/user-register.reducer';

@Component({
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-role-user-register',
   styleUrls: [],
   templateUrl: './role-user-register.component.html',
   standalone: false,
})
export class RoleUserRegisterComponent extends Register<UserRegisterListItem, UserRegisterOptions, OrderingOption> {
   @Input() set userIds(roleUserIds: GetRoleDetail_role_userRolesConnection_items[]) {
      const userIds: number[] = roleUserIds.map((x) => {
         return x.userId;
      });
      const filters: UsersFilterOption[] = [
         {
            field: 'UserId',
            operation: FilterOperations.In,
            type: 'numeric',
            value: userIds.length > 0 ? userIds : [0],
         },
      ];
      this.store.dispatch(roleUsersInitialQuickFilter());
      this.store.dispatch(userRegisterInitialFilter({ filters }));
   }

   @Input() set isOnSystemPage(isOnSystemPage: boolean) {
      if (isOnSystemPage) {
         this.route = systemUsersRoute;
      } else {
         this.route = usersRoute;
      }
   }

   route = usersRoute;

   entityName = 'User';

   columns: string[] = ['username', 'name', 'emailAddress', 'userActionsMenu'];

   columnsIncludingInactive: string[] = ['username', 'name', 'emailAddress', 'isActive', 'userActionsMenu'];

   columns$: Observable<string[]>;

   includeInactive$: Observable<boolean>;

   constructor(public store: Store) {
      super(store, userRegisterReducer.selectors, userRegisterAdapterActions);
      this.includeInactive$ = store.pipe(
         select(userRegisterReducer.selectQuickFilters),
         map((quickFilters) => quickFilters?.includeInactive ?? false)
      );
      this.columns$ = this.includeInactive$.pipe(
         map((includeInactive) => (includeInactive ? this.columnsIncludingInactive : this.columns))
      );
   }
}
